import { GetResponseData, GetResponse } from '@customTypes/api/UserMarketingId';
import { Endpoints, ServiceAPI } from '@service/index';
import queryKeys from '@src/queries/keys';

import { useQuery } from '../helper/useQuery';

const useGetUserMarketingId = (enabled = true) =>
  useQuery<GetResponseData[]>(
    [queryKeys.UserMarketingId],
    () =>
      ServiceAPI.get<null, GetResponse>(Endpoints.UserMarketingId()).then(
        response => response.data.data,
      ),
    {
      enabled,
      cacheTime: 300,
      staleTime: 500,
    },
  );

export default useGetUserMarketingId;
